import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close mobile menu when changing routes
  useEffect(() => {
    setMobileMenuOpen(false);
    // Scroll to top when navigating
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="header-logo">
          <Link to="/">
            <h1>Patients Empowered</h1>
            <p>AI-powered Patient and Provider Empowerment</p>
          </Link>
        </div>

        <button
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="menu-icon"></span>
        </button>

        <nav className={`header-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" className={`nav-link ${isActive('/')}`}>Home</Link>
          <Link to="/about" className={`nav-link ${isActive('/about')}`}>About Us</Link>
          <Link to="/dashboard" className={`nav-link ${isActive('/dashboard')}`}>Dashboard</Link>
          <Link to="/sessions" className={`nav-link ${isActive('/sessions')}`}>Sessions</Link>
          <Link to="/priorv-form" className="nav-cta-btn">Prepare for Your Next Doctor Visit</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
